import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
declare var google: any;

@Component({
  selector: 'lion-gm-place-autocomplete',
  templateUrl: './gm-place-autocomplete.component.html',
  styleUrls: ['./gm-place-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class LiongmPlaceAutocompleteComponent implements OnInit, OnChanges {
  apiLoaded : any = false;
  @ViewChild('appGmAutocomplete') gmAuto: ElementRef<HTMLInputElement>;
  mapAutocomplete : any;
  eventListener:any;
  @Input() formattedAddress : string;
  @Input() displayAddEditRoute : any;
  @Input() disabled : boolean = false;

  place : any;
  @Output() onAddressChange: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveAddress: EventEmitter<any> = new EventEmitter();
  @Output() onSettingAddrress: EventEmitter<any> = new EventEmitter();

  formattedaddress :string = '';
  ErrorMessageSetLocation :string ='';
  constructor(httpClient: HttpClient, public el: ElementRef, public ngZone:NgZone) { }

  ngOnInit(): void {
    ////console.log("native ele",this.el.nativeElement);
    ////console.log("formatted address",this.formattedAddress);
    this.initialize();
  }



ngOnChanges(changes: SimpleChanges): void{
  if(!!changes.formattedAddress && changes.formattedAddress.currentValue !== changes.formattedAddress.previousValue){
    this.el.nativeElement.children[0].value = changes.formattedAddress.currentValue;
  }
  // ////console.log("simple changes", changes);
  // if(!!changes.formattedAddress && changes.formattedAddress.currentValue !== changes.formattedAddress.previousValue){
  //   this.el.nativeElement.children[0].value = changes.formattedAddress.currentValue;
  //   if (!this.mapAutocomplete && this.el.nativeElement.offsetParent) {
  //     this.initialize();
  // }else{
  //   let place = this.mapAutocomplete.getPlace();
  //   ////console.log(place);
  // }
  // }
}
initialize() {
  if (!this.isGoogleLibExists())
        throw new Error("Google maps library can not be found");

  try{
    this.mapAutocomplete = new google.maps.places.Autocomplete(this.el.nativeElement.children[0]);
  }catch(e){
    //debugger;
    ////console.log(e);
  }


  if (!this.mapAutocomplete)
      throw new Error("Autocomplete is not initialized");

  if (!this.mapAutocomplete.addListener != null) {
      this.eventListener = this.mapAutocomplete.addListener('place_changed', () => {
          this.handleChangeEvent()
      });
  }

  this.el.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
      if(!event.key) {
          return;
      }

      let key = event.key.toLowerCase();

      if (key == 'enter' && event.target === this.el.nativeElement) {
          event.preventDefault();
          event.stopPropagation();
      }
  });
}

private handleChangeEvent(): void {
  this.ngZone.run(() => {
      this.place = this.mapAutocomplete.getPlace();

      if (this.place) {
          this.onAddressChange.emit(this.place);
      }
  });
}
private isGoogleLibExists(): boolean {
  return !(!google || !google?.maps || !google?.maps?.places);
}

  public AddressChange(address: any) {
    //setting address from API to local variable
     this.formattedaddress=address.formatted_address;
     //this.ErrorMessageSetLocation = ErrorMessageSetLocation;
     ////console.log("app main location auto complete"+this.formattedaddress);
  }


  onValidate(Data) {
    if (Data.target.value.trim() == "" || Data.target.value.trim() == undefined) {
      this.onRemoveAddress.emit();
      this.ErrorMessageSetLocation = 'Set Location Is Required';
    }
    else
    {
      this.onSettingAddrress.emit(Data.target.value);
      this.ErrorMessageSetLocation = '';
    }
  }

}
